import { isPast } from 'date-fns'
import { FC, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Col, DatePicker, Form, Row } from '@vivaldis/antd-ui'
import { ImageUpload } from '../../../../../../components/ImageUpload'
import { useForm } from '../../../../provider/FormProvider'

export const WorkPermit: FC = () => {
  const [t] = useTranslation('web_ui')

  const { values, setFieldError, setFieldTouched, setFieldValue } = useForm()

  const disabledDate = useCallback((date: Date) => {
    return isPast(date)
  }, [])

  return (
    <>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="workPermitFrontPictureFile"
            required
            label={t(
              'edit_employee_personal_information_form.steps.add_work_permit.work_permit_front_picture.label'
            )}
          >
            <ImageUpload
              defaultSrc={undefined}
              fieldName={'workPermitFrontPictureFile'}
              value={values.workPermitFrontPictureFile}
              setFieldError={setFieldError}
              setFieldTouched={setFieldTouched}
              setFieldValue={setFieldValue}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="workPermitBackPictureFile"
            required
            label={t(
              'edit_employee_personal_information_form.steps.add_work_permit.work_permit_back_picture.label'
            )}
          >
            <ImageUpload
              defaultSrc={undefined}
              fieldName={'workPermitBackPictureFile'}
              value={values.workPermitBackPictureFile}
              setFieldError={setFieldError}
              setFieldTouched={setFieldTouched}
              setFieldValue={setFieldValue}
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item
        name="workPermitExpiresOn"
        required
        label={t(
          'edit_employee_personal_information_form.steps.add_work_permit.work_permit_expires_on.label'
        )}
      >
        <DatePicker
          name="workPermitExpiresOn"
          format="dd-MM-yyyy"
          placeholder={t('form.required')}
          disabledDate={disabledDate}
          style={{ width: '100%' }}
          autoComplete="off"
        />
      </Form.Item>
    </>
  )
}
